import { lazy } from 'react';

export const LazyDropboxErrorPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--dropbox-error-page" */ './dropbox-error-page'
    ),
);
